import { Col, Row, Typography } from "antd";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const MLSDescription = () => {
   const navigate = useNavigate()
  const { Text } = Typography;
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>

      <Col span={24}>
        <Row gutter={[0, 20]}>
          <Col xs={24}>
            <StaticPageBanner
              title={"PPS Nedir"}
              description={"Portföy Paylaşım Sistemi"}
            />
            <Helmet>
              <title className="capitalize">{"PPS Nedir?"}</title>
            </Helmet>
          </Col>

          <Col xs={24} className="!px-2 lg:!px-6 xxl:!px-16">
            <div className="space-y-6  bg-white rounded-lg ">




              <h3 className="text-lg font-bold">
                Portföy Paylaşım Sistemi (PPS) Nedir?
              </h3>


              <p className="text-gray-700">
                Portföy Paylaşım Sistemi (PPS), emlak sektöründe faaliyet
                gösteren kurumsal hesap sahiplerinin, ilanlarını daha geniş bir
                kitleye ulaştırmasını sağlayan yenilikçi bir sistemdir. Bu
                sistem sayesinde, bir kurumsal hesap sahibi, başka kurumsal
                hesaplara sahip emlak ofisleri ile iş birliği yaparak ilanlarını
                paylaşabilir ve ilanlarının daha kısa sürede gerçek müşterilere
                ulaşmasını sağlayabilir.
              </p>

              {/* PPS Nasıl Çalışır? */}
              <h3 className="text-lg font-bold">PPS Nasıl Çalışır?</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  <strong>Kurumsal Hesap Gerekliliği:</strong> PPS sistemini
                  kullanabilmek için kullanıcıların platformda kurumsal bir
                  hesaba sahip olması gerekmektedir.
                </li>
                <li>
                  <strong>İlan Paylaşımı:</strong> Kullanıcılar, ilanlarını
                  "İlanlarım" bölümünden yönetebilir ve "PPS Ekle" butonu ile
                  paylaşabilirler.
                </li>
                <li>
                  <strong>Bölgesel ve Filtreleme Seçenekleri:</strong> İlan
                  paylaşırken belirli bölgelerdeki emlak ofisleri ile iş birliği
                  yapma seçeneği sunulur.
                </li>
                <li>
                  <strong>Komisyon Paylaşımı:</strong> İlan paylaşımı belirli
                  bir komisyon oranı ile gerçekleştirilir, böylece ortak
                  satışlardan gelir elde edilebilir.
                </li>
                <li>
                  <strong>Emlak Ofisleri ile İletişim:</strong> Sistem, ilgili
                  ilanı görebilecek ve iş birliği yapabilecek emlak ofislerini
                  listeleyerek, ilan sahibinin en uygun iş ortaklarını bulmasına
                  yardımcı olur.
                </li>
              </ul>

              {/* PPS’in Avantajları */}
              <h3 className="text-lg font-bold">PPS’in Avantajları</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  <strong>Daha Geniş Kitleye Ulaşım:</strong> İlanlar, başka
                  emlak ofisleri aracılığıyla daha geniş bir alıcı kitlesine
                  ulaşır.
                </li>
                <li>
                  <strong>Satış Sürecinin Hızlanması:</strong> İlanların daha
                  fazla kişi tarafından görülmesi, potansiyel alıcı sayısını
                  artırarak satış süreçlerini hızlandırır.
                </li>
                <li>
                  <strong>Komisyonlu Çalışma Modeli:</strong> Emlak ofisleri,
                  uygun ilanları belirli bir komisyon karşılığında paylaşarak
                  gelir elde edebilir.
                </li>
                <li>
                  <strong>Bölgesel Hedefleme:</strong> Kullanıcılar, belirli
                  bölgelerdeki emlak ofisleri ile çalışarak hedef kitleye daha
                  etkili şekilde ulaşabilir.
                </li>
                <li>
                  <strong>Şeffaf ve Güvenilir İş Birliği:</strong> Sistem, ilan
                  sahipleri ile emlak ofisleri arasındaki iş birliğini şeffaf ve
                  adil bir şekilde yürütmeyi amaçlar.
                </li>
              </ul>

              {/* Sonuç */}
              <p className="text-gray-700 !f">
                Sonuç olarak, PPS sistemi, emlak sektöründe iş birliğini
                güçlendirerek hem ilan sahipleri hem de emlak ofisleri için
                kazançlı ve verimli bir çözüm sunmaktadır. Bu sistem sayesinde,
                ilanlar doğru hedef kitleye ulaştırılarak en kısa sürede gerçek
                alıcılarla buluşturulur ve satış süreci hızlandırılır.
              </p>
              <div className="flex justify-center"><button type="button" onClick={() => navigate("/kurumsal/kayit")} className="ant-btn css-dev-only-do-not-override-161f05s ant-btn-primary ant-btn-color-primary ant-btn-variant-solid !bg-black !p-6 hover:!bg-white hover:!border hover:!border-black group transition-all duration-300 ease-in-out"><span className="ant-typography !text-white group-hover:!text-black transition-all duration-300 ease-in-out css-dev-only-do-not-override-161f05s">Kurumsal Üye Ol</span></button></div>
            </div>
          </Col>
        </Row>
      </Col>

    </>
  );
};

export default MLSDescription;
